<div
  class="min-h-screen pb-page-bottom"
  [class.bg-cover]="backgroundImage && backgroundImageSize === 'cover'"
  [class.bg-center]="backgroundImagePosition === 'center'"
  [class.bg-top]="backgroundImagePosition === 'top'"
  [class.bg-bottom]="backgroundImagePosition === 'bottom'"
  [ngClass]="kioskDisplay ? 'flex flex-col gap-2 kiosk-xl:gap-5' : ''"
  [style.backgroundColor]="backgroundColor | contentBuilderColor: '#FFFFFF'"
  [style.backgroundImage]="backgroundImage ? 'url(' + backgroundImage.url + ')' : 'initial'"
  [style.backgroundSize]="backgroundSizeCss"
  [style.backgroundRepeat]="backgroundRepeatCss"
>
  <app-block-list [blockIdList]="body"></app-block-list>
</div>
<app-block-list [blockIdList]="footer"></app-block-list>
